export const PROCESSES_REPORT_COLUMN_FIELD_CODES = {
  'Ref. Prime': 'REF_PRIME',
  Etapa: 'ETAPA',
  Empresa: 'EMPRESA',
  Exportador: 'EXPORTADOR',
  'Ref. Pedido': 'REF_PEDIDO',
  'Outras referências': 'OUTRAS_REFERENCIAS',
  Status: 'STATUS',
  Invoice: 'INVOICE',
  Moeda: 'MOEDA',
  'Via de Transporte': 'VIA_DE_TRANSPORTE',
  Incoterm: 'INCOTERM',
  Forwarder: 'FORWARDER',
  CNTR: 'CNTR',
  'Data de Abertura': 'DATA_DE_ABERTURA',
  'Previsão da Prontidão de Carga': 'PREVISAO_DA_PRONTIDAO_DE_CARGA',
  ETD: 'ETD',
  ETA: 'ETA',
  'Previsão da Entrega': 'PREVISAO_DA_ENTREGA',
  'Previsão de Numerário': 'PREVISAO_DE_NUMERARIO',
  'Prontidão de Carga': 'PRONTIDAO_DE_CARGA',
  Coleta: 'COLETA',
  Embarque: 'EMBARQUE',
  Chegada: 'CHEGADA',
  'Nº DI / DUIMP': 'NUMERO_DI_DUIMP',
  'Versão DUIMP': 'VERSAO_DUIMP',
  'Chave Duimp': 'CHAVE_DUIMP',
  'Nº do Protocolo': 'NUMERO_DO_PROTOCOLO',
  'Data de Registro': 'DATA_DE_REGISTRO',
  'Data de Desembaraço': 'DATA_DE_DESEMBARACO',
  Canal: 'CANAL',
  Carregamento: 'CARREGAMENTO',
  'Entrega no Cliente': 'ENTREGA_NO_CLIENTE',
  'Valor CIF': 'VALOR_CIF',
};
